<div class="color-item"><span class="color-item-label">Color</span><div class="color-item-wheel" :style="{'background-color': hexColor}"></div></div>